// extracted by mini-css-extract-plugin
export default {"list":"style_list__VNr2+","title":"style_title__bF-S2"};